

import React, { useRef, useEffect, memo } from 'react';
import cx from 'classnames';
import { Icon, Input } from '../../../../../../../ui-kit';
import { convertCurrency } from '../../../../../../../common/utils';
import { CURRENCY_BY_ENTITY_CODE } from '../../../../../../../common/constants/currency';
import '../../../styles/_edit-cost.scss';













const onChangeCostValue = ({
  costValue,
  onChangeCost,
  isVoiceOverAddon,
  currencySymbol
}) => {
  const { value: newCost } = costValue;
  const roundedCost = Math.round(newCost) || 0;

  if (!isVoiceOverAddon) {
    return void onChangeCost(roundedCost);
  }

  const convertedCost = convertCurrency({
    fromCurrency: 'USD',
    toCurrency: currencySymbol,
    value: roundedCost
  });

  onChangeCost(convertedCost);
};

function EditCost({
  cost,
  addonName,
  onChangeCost,
  getCurrencySymbol,
  getCurrencyIcon,
  className,
  disabled,
  getBillingEntityCode,
  getCurrency
}) {
  const inputEl = useRef(null);
  const isVoiceOverAddon = ['VOICE_OVER_ARTIST', 'VOICE_OVER_ARTISTS'].includes(addonName);
  const isCustomAddon = addonName === 'CUSTOM_ADDON';
  const currencyIcon = getCurrencyIcon ? getCurrencyIcon() : '';
  const currencySymbol = getCurrencySymbol && getCurrencySymbol() ? getCurrencySymbol().replace(currencyIcon, '').trim() : '';
  const billingEntityCode = getBillingEntityCode && getBillingEntityCode();
  const currency = getCurrency && getCurrency();
  const currencySymbolToConvert = currencySymbol || (
  billingEntityCode ? CURRENCY_BY_ENTITY_CODE[billingEntityCode] : '');
  const defaultValue = isVoiceOverAddon ?
  convertCurrency({
    fromCurrency: currencySymbolToConvert,
    value: parseInt(cost, 10) || 0,
    toBaseCurrency: true
  }) : cost;

  useEffect(() => {
    if (!inputEl || !inputEl.current) {
      return;
    }

    inputEl.current.setState({ value: defaultValue });
  });

  return (
    <div className={cx('edit-cost', className)}>
      <div className="edit-cost__container">
        {isVoiceOverAddon ? 'USD' : currencySymbol}
        {' '}
        <div className={cx('edit-cost__input-container',
        { 'edit-cost__input-container__custom-addon': isCustomAddon }
        )}>

          <Input
            ref={inputEl}
            onBlur={(costValue) => onChangeCostValue({
              costValue,
              onChangeCost,
              isVoiceOverAddon,
              currencySymbol: currencySymbolToConvert
            })}
            defaultValue={defaultValue || '0'}
            disabled={disabled}
            type="number" />

          <div className="currency-icon">{isVoiceOverAddon ? '$' : currencyIcon}</div>
          {isCustomAddon && <div className="currency-unit">{currency}</div>}
        </div>
      </div>
      {
      isVoiceOverAddon &&
      <div className="edit-cost__converted-value">
            <span className="edit-cost__converted-value--symbol">{currencySymbol}</span>
            <div className="edit-cost__converted-value--cost">
              {`${currencyIcon}${cost}`}
              <Icon
            name="info"
            size={16}
            tooltipId="markup-info"
            tooltipLabel="Include Currency Markup"
            tooltipPlace="top" />

            </div>
          </div>}


    </div>);

}

export default memo(EditCost);